import { Background } from './Background';

export const ShoutzBackground = ({ color }) => {
	return <Background color={color} />;
};
